module.exports = __webpack_public_path__ + "media/icons/i-8-settings-466cb2cb.png";